import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { LayoutGridItem } from 'app/layout/LayoutGrid';
import { missingField } from 'app/constants';
import FederalIcon from 'app/assets/images/Placement/Federal.svg';
import AMNLogo from 'app/assets/images/Placement/AMNLogo.svg';
import Facility from 'app/assets/images/Placement/Facility.svg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import State from 'app/assets/images/Placement/State.svg';
import { useComplianceCollapseStyles } from './ComplianceCollapse';
import DocumentIcon from 'app/assets/images/description-24px.svg';
import { getIconStatus, setBorderColor } from './helper';
import { IEngineRequirement } from 'app/models/Placement/CredOneCompliance';

/**
 * Component to display the requirement name and its rule name
 */
const RequirementHeaderContainer = ({ headerContent, icon }) => {
  return (
    <LayoutGridItem container item>
      <LayoutGridItem sx={{ display: 'flex', alignItems: 'center' }}>{icon}</LayoutGridItem>
      <LayoutGridItem sx={{ paddingLeft: '10px' }} xs={11}>
        {headerContent}
      </LayoutGridItem>
    </LayoutGridItem>
  );
};

/**
 * Component to render icons in requirement collapse
 */
const RequirementsIconContainer = ({ sx, isSubAsset = false }) => {
  return isSubAsset ? (
    <LayoutGridItem container item sx={sx}>
      <img src={DocumentIcon} alt={`requirements-doc-img`} style={{ marginRight: '5px' }} id="requirements-doc-image" />
    </LayoutGridItem>
  ) : (
    <LayoutGridItem container item sx={sx}>
      <img src={State} alt={`requirements-state-img`} id="requirements-state-image" />
      <img src={AMNLogo} alt={`requirements-logo-img`} style={{ marginLeft: '12px' }} id="requirements-logo-image" />
      <img
        src={FederalIcon}
        alt={`requirements-federal-img`}
        style={{ marginLeft: '12px' }}
        id="requirements-federal-image"
      />
      <img
        src={Facility}
        alt={`requirements-facility-img`}
        style={{ marginLeft: '12px', marginRight: '5px' }}
        id="requirements-facility-image"
      />
    </LayoutGridItem>
  );
};

/**
 * Component to render requirements according (top layer accordion)
 */
const RequirementsAccordion = ({
  complianceItem,
  children,
  index,
}: {
  complianceItem: IEngineRequirement;
  children?: any;
  index: number;
}) => {
  const { classes } = useComplianceCollapseStyles();

  /**
   *  Method to render requirements header
   */
  const requirementsHeaderText = (complianceItem: IEngineRequirement) => {
    return (
      <>
        <Typography sx={{ color: '#333333' }}>{complianceItem.name}</Typography>
        <Typography sx={{ fontSize: '12px !important', color: '#75787B' }}>
          {complianceItem?.rules?.length ? complianceItem?.rules[0].name : missingField}
        </Typography>
      </>
    );
  };

  return (
    <Accordion className={classes.hideBorder} key={index} id="requirement-accordion">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="compliance-accordion-expand"
      >
        <RequirementHeaderContainer
          headerContent={requirementsHeaderText(complianceItem)}
          icon={getIconStatus(complianceItem?.result, complianceItem?.isAssetExists)}
        />
        <RequirementsIconContainer sx={{ display: 'flex', justifyContent: 'flex-end' }} />
      </AccordionSummary>
      <AccordionDetails
        sx={{
          background: 'rgb(250, 250, 250, 1)',
          borderLeft: setBorderColor(complianceItem?.result, complianceItem?.isAssetExists),
          paddingBottom: '6px',
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export { RequirementHeaderContainer, RequirementsIconContainer, RequirementsAccordion };
